/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type appQuickbooks_viewer = {
    readonly id: string;
    readonly company: {
        readonly id: string;
        readonly quickbooksEnabled: boolean | null;
    } | null;
    readonly " $refType": "appQuickbooks_viewer";
};
export type appQuickbooks_viewer$data = appQuickbooks_viewer;
export type appQuickbooks_viewer$key = {
    readonly " $data"?: appQuickbooks_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"appQuickbooks_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appQuickbooks_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quickbooksEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'a6d5fdc38954f2c51843471ff2b2c5e1';
export default node;
